import React from 'react';
import { get } from 'lodash';
import { FieldError as IFieldError, useFormContext } from 'react-hook-form';
import { Flex } from '@chakra-ui/react';
import { TextArea } from '@morressier/alembic';
import { FieldLabel } from '../Field';
import { IFormFieldText } from '../Submission/GenericFieldComponents/Text';
import { getValidationTypedMessage } from './common/errorMessages';

interface IFormFieldTextAreaProps {
  config: IFormFieldText;
  placeholder?: string;
  isEditingAllowed?: boolean;
}

const FormFieldTextArea: React.FC<IFormFieldTextAreaProps> = ({
  config,
  placeholder,
  isEditingAllowed = true
}) => {
  const {
    register,
    formState: { errors },
    watch
  } = useFormContext();

  const {
    name,
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;

  const error = get(errors, field) as IFieldError;
  const value = watch(field) as string;

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <FieldLabel
        label={labels.main}
        subText={labels.subtitle}
        isRequired={validations.required}
        helpText={labels.helpText}
      />
      <TextArea
        value={value}
        id={name}
        height={`${value?.length ?? 1 * 0.75}px`}
        minHeight={100}
        maxHeight={600}
        {...register(field)}
        isInvalid={!!error}
        placeholder={placeholder || labels.placeholder}
        errorMessage={
          error &&
          getValidationTypedMessage(
            labels.main === ' ' &&
              placeholder === 'Provide any additional details'
              ? 'Field'
              : labels.main,
            validations.kind,
            validations,
            error
          )
        }
        isReadOnly={!isEditingAllowed}
      />
    </Flex>
  );
};

export default FormFieldTextArea;
